import { getLocale } from '@helpers/env'

const productDiscountQuery = `query($preview: Boolean) {
  productDiscount: productDiscountCollection(limit: 100, locale: "${getLocale()}", preview: $preview) {
    items {
      discountTitle
      discountDescription
      productTypes
      visibility
    }
  }
}`

export default productDiscountQuery
